import { render } from "./copyLayerToOthersModal.vue?vue&type=template&id=3fedced4&scoped=true&ts=true"
import script from "./copyLayerToOthersModal.vue?vue&type=script&lang=ts"
export * from "./copyLayerToOthersModal.vue?vue&type=script&lang=ts"

import "./copyLayerToOthersModal.vue?vue&type=style&index=0&id=3fedced4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fedced4"]])

export default __exports__